const WishlistToast = {

    timer:null,

    show(title,text,type="success"){

        let toast=document.querySelector(".wishlist-toast");

        if(!toast){

            toast=document.createElement("div");

            toast.className="wishlist-toast";

            document.body.appendChild(toast);

        }

        toast.className=`wishlist-toast is-show is-${type}`;

        toast.innerHTML=`

            <div class="wishlist-toast__icon">

                ${type==="success"?"❤":"⚠"}

            </div>

            <div class="wishlist-toast__content">

                <div class="wishlist-toast__title">

                    ${title}

                </div>

                <div class="wishlist-toast__text">

                    ${text}

                </div>

            </div>

        `;

        clearTimeout(this.timer);

        this.timer=setTimeout(()=>{

            toast.classList.remove("is-show");

        },2500);

    }

};

window.WishlistToast=WishlistToast;